export default __webpack_public_path__ + "static/media/cover-light.167ce2a0.png";